// feat/car-inquiry-inbox (2026-05-26) — 업체 ERP 매물 문의 인박스 (C/M3)
// 외부 바이어가 전체매물에서 보낸 차량별 문의를 업체가 조회/확인.
// 백엔드: GET /api/inquiries, PATCH /api/inquiries/:id/read.
// feat/inquiry-chat (2026-05-26) — 💬 대화: GET/POST /api/inquiries/:id/messages (ko↔locale 통역).

import React, { useState, useEffect, useCallback } from 'react';
import { API, authFetch } from '../utils/api';

var STATUS_META = {
  'new':       { label: '신규',   bg: '#fef3c7', color: '#92400e' },
  'read':      { label: '확인',   bg: '#dbeafe', color: '#1e40af' },
  'responded': { label: '응답함', bg: '#dcfce7', color: '#166534' },
  'closed':    { label: '종료',   bg: '#f1f5f9', color: '#64748b' },
};

function fmtDate(s) {
  if (!s) return '';
  return String(s).slice(0, 16).replace('T', ' ');
}

function CarInquiryInbox(props) {
  var showToast = props.showToast || function(){};
  var [items, setItems] = useState([]);
  var [loading, setLoading] = useState(true);
  var [statusFilter, setStatusFilter] = useState('');
  // 💬 대화 스레드
  var [threadId, setThreadId] = useState(null);
  var [threadItems, setThreadItems] = useState([]);
  var [threadHeader, setThreadHeader] = useState(null);
  var [threadLoading, setThreadLoading] = useState(false);
  var [replyText, setReplyText] = useState('');
  var [sending, setSending] = useState(false);

  var load = useCallback(function() {
    setLoading(true);
    var url = API + '/inquiries' + (statusFilter ? ('?status=' + statusFilter) : '');
    authFetch(url).then(function(r){ return r.json(); }).then(function(d){
      if (d && d.success) setItems(d.data || []);
      setLoading(false);
    }).catch(function(){ setLoading(false); });
  }, [statusFilter]);

  useEffect(function(){ load(); }, [load]);

  function markRead(id) {
    authFetch(API + '/inquiries/' + id + '/read', { method: 'PATCH' })
      .then(function(r){ return r.json(); })
      .then(function(d){ if (d && d.success) { load(); if (props.onRead) props.onRead(); } else showToast('처리 실패', 'err'); })
      .catch(function(){ showToast('서버 오류', 'err'); });
  }

  function loadThread(id) {
    setThreadLoading(true);
    authFetch(API + '/inquiries/' + id + '/messages')
      .then(function(r){ return r.json(); })
      .then(function(d){ if (d && d.success && d.data) { setThreadItems(d.data.items || []); setThreadHeader(d.data.header || null); } setThreadLoading(false); })
      .catch(function(){ setThreadLoading(false); });
  }
  function openThread(it) {
    setThreadId(it.id); setThreadItems([]); setThreadHeader(null); setReplyText('');
    loadThread(it.id);
    markRead(it.id);   // 확인 처리 (status + 배지 동기화) — 멱등
  }
  function sendReply() {
    var body = replyText.trim();
    if (!body || sending) return;
    setSending(true);
    authFetch(API + '/inquiries/' + threadId + '/messages', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body: body }) })
      .then(function(r){ return r.json(); })
      .then(function(d){ setSending(false); if (d && d.success) { setReplyText(''); loadThread(threadId); load(); } else showToast('전송 실패', 'err'); })
      .catch(function(){ setSending(false); showToast('서버 오류', 'err'); });
  }

  var newCount = items.filter(function(i){ return i.status === 'new'; }).length;

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: '#1B3A5C', margin: 0 }}>📨 매물 문의 ({items.length})</h2>
        {newCount > 0 && <span style={{ background: '#ef4444', color: '#fff', borderRadius: 999, padding: '2px 10px', fontSize: 12, fontWeight: 700 }}>신규 {newCount}</span>}
        <select value={statusFilter} onChange={function(e){ setStatusFilter(e.target.value); }}
          style={{ marginLeft: 'auto', padding: '6px 10px', borderRadius: 6, border: '1px solid #d0d5dd', fontSize: 13, color: '#475569', cursor: 'pointer' }}>
          <option value="">전체</option>
          <option value="new">신규</option>
          <option value="read">확인</option>
          <option value="responded">응답함</option>
          <option value="closed">종료</option>
        </select>
        <button onClick={load} style={{ padding: '6px 14px', borderRadius: 6, border: '1px solid #1B3A5C', background: '#1B3A5C', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>새로고침</button>
      </div>

      <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 14 }}>
        외부 바이어가 전체매물 페이지에서 보낸 문의입니다. 응답은 바이어 연락처/채팅으로 진행하세요.
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 50, color: '#94a3b8' }}>불러오는 중...</div>
      ) : items.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 50, color: '#94a3b8', background: '#f8fafc', borderRadius: 12, border: '1px dashed #e2e8f0' }}>받은 문의가 없습니다</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {items.map(function(it) {
            var sm = STATUS_META[it.status] || STATUS_META['new'];
            return (
              <div key={it.id} style={{ background: '#fff', border: '1px solid ' + (it.status === 'new' ? '#fcd34d' : '#e2e8f0'), borderRadius: 12, padding: '14px 18px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
                  <span style={{ background: sm.bg, color: sm.color, borderRadius: 999, padding: '2px 10px', fontSize: 12, fontWeight: 700 }}>{sm.label}</span>
                  <span style={{ fontWeight: 800, color: '#0f172a', fontSize: 15 }}>{it.carNo || ('차량 #' + it.car_id)}</span>
                  <span style={{ color: '#64748b', fontSize: 13 }}>{it.carType || ''}</span>
                  <span style={{ marginLeft: 'auto', fontSize: 12, color: '#94a3b8' }}>{fmtDate(it.created_at)}</span>
                </div>
                <div style={{ fontSize: 13, color: '#475569', marginBottom: 8 }}>
                  👤 {it.buyer_name || '바이어'}{it.buyer_country ? ' · ' + it.buyer_country : ''}{it.locale ? ' · ' + it.locale : ''}
                </div>
                {it.message && (
                  <div style={{ fontSize: 14, color: '#0f172a', background: '#f8fafc', borderRadius: 8, padding: '10px 14px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{it.message}</div>
                )}
                <div style={{ marginTop: 10, textAlign: 'right' }}>
                  <button onClick={function(){ openThread(it); }}
                    style={{ padding: '6px 14px', borderRadius: 6, border: '1px solid #1B3A5C', background: '#1B3A5C', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
                    💬 대화
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {threadId && (
        <div onClick={function(){ setThreadId(null); }} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
          <div onClick={function(e){ e.stopPropagation(); }} style={{ background: '#fff', borderRadius: 16, width: '100%', maxWidth: 560, maxHeight: '82vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontWeight: 800, color: '#1B3A5C' }}>💬 {threadHeader ? (threadHeader.carNo || threadHeader.carType || '대화') : '대화'}</span>
              <span style={{ fontSize: 12, color: '#94a3b8' }}>{threadHeader ? (threadHeader.buyerName || '') + (threadHeader.buyerCountry ? ' · ' + threadHeader.buyerCountry : '') : ''}</span>
              <button onClick={function(){ setThreadId(null); }} style={{ marginLeft: 'auto', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 18, color: '#94a3b8' }}>✕</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '14px 18px', background: '#f8fafc', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {threadLoading ? (
                <div style={{ textAlign: 'center', color: '#94a3b8', padding: 20 }}>불러오는 중...</div>
              ) : threadItems.map(function(m, i) {
                var mine = m.isMine;   // 업체 측 메시지
                return (
                  <div key={m.id + '-' + i} style={{ alignSelf: mine ? 'flex-end' : 'flex-start', maxWidth: '80%' }}>
                    <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 2, textAlign: mine ? 'right' : 'left' }}>{m.senderName || ''}</div>
                    <div style={{ background: mine ? '#1B3A5C' : '#fff', color: mine ? '#fff' : '#0f172a', border: mine ? 'none' : '1px solid #e2e8f0', borderRadius: 12, padding: '8px 12px', fontSize: 14, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {(!mine && m.bodyTranslated)
                        ? (<><div>{m.bodyTranslated}</div><div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{m.body}</div></>)
                        : m.body}
                    </div>
                    <div style={{ fontSize: 10, color: '#cbd5e1', marginTop: 2, textAlign: mine ? 'right' : 'left' }}>{fmtDate(m.createdAt)}</div>
                  </div>
                );
              })}
            </div>
            <div style={{ padding: '12px 14px', borderTop: '1px solid #eee', display: 'flex', gap: 8 }}>
              <input value={replyText} onChange={function(e){ setReplyText(e.target.value); }} onKeyDown={function(e){ if (e.key === 'Enter') sendReply(); }}
                placeholder="답장 입력 (바이어 언어로 자동 통역)"
                style={{ flex: 1, border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '10px 12px', fontSize: 14, outline: 'none' }} />
              <button onClick={sendReply} disabled={sending}
                style={{ padding: '0 18px', borderRadius: 10, border: 'none', background: sending ? '#cbd5e1' : '#1B3A5C', color: '#fff', fontWeight: 700, cursor: sending ? 'not-allowed' : 'pointer' }}>
                {sending ? '전송…' : '전송'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CarInquiryInbox;
